
function GridIsotope() {

    this.build();

}

GridIsotope.prototype.build = function(){

    let that = this;
    that.container_news = $('.grid-news');

    that.container_news.isotope({
        itemSelector: '.grid-news__item',
        percentPosition: true,
        masonry: {
            gutter: '.grid-news__sizer',
            horizontalOrder: true
        }
    });

    that.container_team = $('.grid-team');

    that.container_team.isotope({
        itemSelector: '.grid-team__item',
        percentPosition: true,
        getSortData: {
            job: '[data-job]'
        },
        sortBy : ['job'],
        masonry: {
            columnWidth: '.grid-sizer',
            gutter: '.grid-team__sizer',
            horizontalOrder: true
        }
    });

    document.addEventListener('lazyloaded', function(e){
        that.container_team.isotope('layout');
        that.container_news.isotope('layout');
    });

    $('.agency-choices__select').on( 'change', function() {
        let filterValue = $(this).val();
        that.container_team.isotope({ filter: filterValue });
    });

};